/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceConfigurationModel } from '../../models/service-configuration-model';

export interface ServiceConfigurationExtendedHoursOfOperationGet$Params {
  parentOrgId?: string;
  hcsId?: string;
  locationId?: string;
  specialityId?: string;
  targetDate?: string | null;
}

export function serviceConfigurationExtendedHoursOfOperationGet(http: HttpClient, rootUrl: string, params?: ServiceConfigurationExtendedHoursOfOperationGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, serviceConfigurationExtendedHoursOfOperationGet.PATH, 'get');
  if (params) {
    rb.query('parentOrgId', params.parentOrgId, {});
    rb.query('hcsId', params.hcsId, {});
    rb.query('locationId', params.locationId, {});
    rb.query('specialityId', params.specialityId, {});
    rb.query('targetDate', params.targetDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<ServiceConfigurationModel>;
    })
  );
}

serviceConfigurationExtendedHoursOfOperationGet.PATH = '/ServiceConfiguration/ExtendedHoursOfOperation';
